import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { isAdding } from '../../../../entityManagement/selectors';
import { stopEntityAdding } from '../../../../entityManagement/actions';
import DismissibleFormWrapper from '../../DismissibleFormWrapper';
import SingleResourceAddForm from './SingleResourceAddForm';
import ResourceBulkAddForm from './ResourceBulkAddForm';

const ResourceAddForm = ({ scope, form, opened, headerButtonTextKey, onClose }: $TSFixMe) => (
    <DismissibleFormWrapper opened={opened} headerButtonTextKey={headerButtonTextKey} onClose={onClose}>
        <SingleResourceAddForm scope={scope} form={`${form}-single`} />
        <ResourceBulkAddForm scope={scope} form={`${form}-paste`} />
    </DismissibleFormWrapper>
);

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        opened: isAdding,
        headerButtonTextKey: () => TextKey.NewSpace,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        onClose: () => dispatch(stopEntityAdding(scope)),
    })
)(ResourceAddForm);
